// Added 11Jul2026 - Hover label update for Linkify Product Colors swatches
(function() {
  function initColorHover() {
    var colorLabel = document.querySelector('.product-color');
    if (!colorLabel) return false;
    var swatches = document.querySelectorAll('linkify-product-colors-swatch');
    if (swatches.length === 0) return false;
    var originalText = colorLabel.textContent.trim();
    swatches.forEach(function(swatch) {
      var colorName = swatch.getAttribute('aria-label');
      swatch.addEventListener('mouseenter', function() {
        colorLabel.textContent = 'Color: ' + colorName;
      });
      swatch.addEventListener('mouseleave', function() {
        colorLabel.textContent = originalText;
      });
    });
    return true;
  }

  if (!initColorHover()) {
    var observer = new MutationObserver(function() {
      if (initColorHover()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { initColorHover(); observer.disconnect(); }, 5000);
  }
})();
